import { render, staticRenderFns } from "./important-tickets.vue?vue&type=template&id=44a29da4"
import script from "./important-tickets.vue?vue&type=script&lang=js"
export * from "./important-tickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports